import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CostCenterUserService {

  constructor(private _httpClient: HttpClient) { }

  getCostCenterUsers(userId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean,
    filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('userId', userId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterUser.GetCostCenterUsersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsCostCenterUserAsync(userId: number): Observable<ColumnResponseModel[]> {
    const params = new HttpParams().set('userId', userId);
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterUser.GetColumnsCostCenterUserAsync}`,
      { params: params });
  }

  saveCostCenterUser(userId: number, costCenterId: number): Observable<any> {
    const params = new HttpParams().set('userId', userId).set('costCenterId', costCenterId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterUser.SaveCostCenterUserAsync}`,
      { params: params })
  }
}
